<template>
  <v-card>
    <v-card-text class="pa-0">
      <v-container class="pa-0">
        <router-link :to="to">
          <div class="layout row ma-0" v-ripple>
            <div v-if="!$vuetify.breakpoint.xs" class="sm6 xs12 flex">
              <div class="layout column ma-0 justify-center align-center">
                <v-icon size="65px" :color="color">{{ icon }}</v-icon>
              </div>
            </div>
            <div
              class="sm6 xs12 flex text-sm-center py-3 white--text"
              :class="color"
            >
              <div v-if="!loaded">
                <v-progress-circular
                  indeterminate
                  :size="32"
                  :width="2"
                  color="white"
                >
                </v-progress-circular>
              </div>
              <div v-else class="headline">{{ counter }}</div>
              <span class="caption">{{ title }}</span>
            </div>
          </div>
        </router-link>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "mini-statistic",
  props: {
    icon: String,
    counter: Number,
    title: String,
    color: String,
    to: Object,
    loaded: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.flex a {
  text-decoration: none;
  color: white;
}
</style>
